export const LOCALES = ['zh', 'en']
export const DEFAULT_LOCALE = 'zh'
export const LOCALE_STORAGE_KEY = 'sn-locale'

export const translations = {
  zh: {
    siteTitle: '香港街道編年',
    seoDescription:
      '以政府憲報整理香港街道命名年份，互動地圖按年代顯示道路，並提供可搜尋街道名錄及社群補充命名日期。',
    navMap: '地圖',
    navNames: '街道',
    navTimelines: '記錄',
    navRecords: '記錄',
    navAbout: '關於',
    langSwitchToEn: 'EN',
    langSwitchToEnLabel: 'English',
    langSwitchAria: '切換至英文介面',
    themeSwitchToLight: '切換至淺色模式',
    themeSwitchToDark: '切換至深色模式',
    themeLight: '淺色模式',
    themeDark: '深色模式',
    navMenuAria: '開啟選單',
    searchRoadIndexing: '正在建立街道索引…',
    searchRoad: '搜尋街道',
    mapLoading: '載入街道中…..',
    evolution: '年代',
    selectDistrict: '選擇地區',
    searchDistrict: '搜尋地區',
    noMatchingSubDistrict: '沒有相符的地區',
    timeline: '時間軸',
    mapHudToolbarAria: '地圖控制',
    mapHudDistrict: '地區',
    mapHudHistoricalMap: '舊地圖',
    historicalMapTitle: '歷史地圖',
    historicalMapNone: '關閉',
    historicalMapEmpty: '尚未建立歷史地圖圖磚。請執行 npm run build:historical-maps。',
    historicalMapLoading: '載入中…',
    historicalMapOpacity: '透明度',
    historicalMapSuggested: '建議',
    historicalMapAttribution: '資料來源：',
    historicalMapDatasetLink: '地政總署歷史地圖',
    mapHudCloseSheet: '關閉',
    mapYearRemarksTitle: '地圖年份說明',
    mapYearRemarksIntro:
      '道路標籤旁的年份與時間軸滑桿，採用下列優先次序決定顯示哪一年：',
    mapYearRemarksBuilt:
      '如有記錄，優先顯示街道落成或開放日期（「建成」事件）。',
    mapYearRemarksNaming:
      '否則顯示最早憲報記載或現用街名的政府命名日期；標有「·提及」者為非命名公告的最早提及，不一定是命名年份。',
    mapYearRemarksTimeline:
      '點選道路可查看完整事件時間軸；落成、最早提及、命名日期可能相距多年。',
    mapYearSuffixAttestation: '·提及',
    mapYearRemarksPending:
      '標示「資料待補」表示尚未有落成或命名年份。',
    timelinePlay: '播放',
    timelinePause: '暫停',
    unknownYear: '資料待補',
    unnamedStreetCode: '街道編號 {code}',
    periodUnknown: '資料待補',
    loadingReport: '正在載入報告…',
    reportError: '找不到街道目錄報告。請先執行 npm run report:pending-years。',
    roadTypesTitle: '道路類型',
    periodStatsTitle: '命名年份分期',
    periodStatsHint:
      '地圖年份：落成 → 最早提及（·提及）→ 最早憲報記載 → 命名；與正式命名年份可能不同。',
    pendingPeriodSubtitle: '按街道目錄上的正式命名年份篩選。',
    timelinesPeriodSubtitle: '按街道時間線上至少一項事件的年份篩選。',
    timelinesPeriodStatsHint: '顯示至少有一項時間線事件落在此十年的街道。',
    recordsGazettesPeriodSubtitle: '按憲報刊登日期年代篩選。',
    periodFilterActive: '已篩選：{period}',
    periodFilterClear: '清除年代篩選',
    periodFilterToggleExpand: '按年代篩選',
    periodFilterToggleCollapse: '收起',
    searchTable: '以街道編號／名稱／類型／年份／日期搜尋',
    showingStreets: '顯示 {shown} / {total} 條街道',
    colStreet: '街道名稱',
    colType: '類型',
    colNaming: '命名日期',
    colMapYear: '地圖年份',
    colNotice: '憲報',
    colSource: '來源',
    colPipeline: '收錄',
    evidenceGazettePrimary: '憲報',
    evidenceGazetteInferred: '憲報（推斷）',
    evidenceGazetteMention: '憲報提及',
    evidenceLegalOther: '其他法律文件',
    evidenceLegalMention: '法律文件提及',
    evidenceResearch: '研究',
    evidenceResearchMention: '研究提及',
    evidenceNews: '新聞',
    evidenceNewsMention: '新聞提及',
    evidenceHearsay: '傳聞',
    evidenceUnknown: '待分類',
    evidenceOther: '其他',
    evidenceGazettePrimaryHint: '命名日期來自該街道的政府憲報公告原文（附 PDF 或連結）。',
    evidenceGazetteInferredHint: '日期或 G.N. 由另一份憲報推斷（例如「Previous G.N.」）；依據見連結。',
    evidenceGazetteMentionHint: '憲報非命名公告中最早出現該街道名稱的記載（例如條例、命令、地址引用）。',
    evidenceLegalOtherHint: '條例、法院、圖則等非憲報命名公告的法律文件。',
    evidenceLegalMentionHint: '法律文件中最早出現該街道名稱的記載。',
    evidenceResearchMentionHint: '研究文獻中最早出現該街道名稱的記載。',
    evidenceNewsMentionHint: '報章或新聞中最早出現該街道名稱的記載。',
    evidenceResearchHint: '學術或文化機構編纂的研究文獻（如古蹟資源中心）。',
    evidenceNewsHint: '報章、雜誌或官方新聞稿等非憲報來源。',
    evidenceHearsayHint: '口傳、論壇等未經核實的二手資料。',
    evidenceUnknownHint: '已有日期，來源尚未標註；歡迎提交憲報 PDF。',
    evidenceOtherHint: '其他來源；見備註。',
    colContribute: '執漏',
    pending: '資料待補',
    truncatedRows: '只顯示首 500 行。請收窄搜尋以查看特定街道。',
    roadTypeHighway: '公路',
    roadTypeMainRoad: '主要道路',
    roadTypeSecondaryRoad: '次要道路',
    roadTypeRestrictedRoad: '限制道路',
    roadTypeTunnel: '隧道',
    roadTypeTrack: '小徑',
    roadTypeUnknown: '未知類型',
    navContribute: '貢獻',
    contributeTitle: '協助補充街道命名日期',
    contributeMission:
      '本圖僅有約 2% 街道有命名年份。若你找到政府憲報「街道命名」公告，歡迎提交證明。',
    contributeNamed: '已有命名日期',
    contributeSubmitted: '已收到證明',
    contributeVerified: '社群已核實',
    contributePending: '仍待補充',
    contributeCoverage: '覆蓋率',
    contributeCta: '前往貢獻',
    contributeSingleTitle: '單一街道',
    contributeSingleDesc: '從街道列表點「提交證明」，或在此開啟表格。需提供命名日期及憲報連結或 PDF。',
    contributeBatchTitle: '批量上傳',
    contributeBatchDesc:
      '有多份憲報 PDF？可直接上傳附件與簡短說明，無需逐條填寫街道名稱；我們會另行處理。',
    contributeBatchCta: '開啟批量表格',
    contributeSingleCta: '開啟單一街道表格',
    contributeProofTitle: '什麼算有效證明？',
    contributeProofItem1: '政府憲報中的「街道命名」宣布公告',
    contributeProofItem2: '公告上的政府憲報編號（如 G.N. 1234）及刊登日期',
    contributeProofItem3: 'egazette.gld.gov.hk 連結或 gazette PDF',
    contributeProofItem4: '非憲報來源（新聞、其他法律文件等）請在備註說明',
    contributeRecentTitle: '最近經社群核實',
    contributeFaqTitle: '提交後多久會更新？',
    contributeFaqInstant: '你本人會立即在列表上看到「你已提交」標記。',
    contributeFaqPublic: '公開的「已提交」狀態通常在數小時內更新（每日同步）。',
    contributeFaqVerified: '地圖上的命名日期需經維護者審核後才會顯示。',
    contributeFormsNotConfigured: '提交表格尚未設定，請參閱專案文件。',
    filterAll: '全部',
    filterPendingDate: '資料待補',
    filterSourceTitle: '來源',
    filterSourceNone: '未標註',
    filterRecentlyVerified: '最近核實',
    filterNeedsProof: '需要證明',
    contributeFillGap: '一齊執漏',
    badgeSubmitted: '已提交',
    badgeSubmittedLocal: '你已提交',
    badgeVerified: '已核實',
    namesContributeHint: '協助補充約 {count} 條待定街道的命名日期。',
    namesBatchBarLink: '批量上傳憲報',
    namesBatchBarSuffix: '（最多 10 份，自動辨識街道名稱及年份）',
    namesNoPost2000Intake: '我們已取得2000年或以後的憲報，現正處理中，請暫不用提交',
    mapSubmitProof: '提交命名證明',
    mapRoadCardClose: '關閉街道卡片',
    mapRoadShare: '分享',
    mapRoadShareAria: '複製街道連結',
    mapRoadShareCopied: '已複製連結',
    colNameHistory: '時間線',
    colRemarks: '備註',
    historyGazettePending: '憲報待補',
    historyGazetteInferred: '推斷憲報',
    eventTypeDeclare: '命名',
    eventTypeRename: '易名',
    eventTypeFormerName: '舊稱',
    eventTypeExtend: '延伸',
    eventTypeBuilt: '落成',
    eventTypeNameRemoved: '名稱撤銷',
    eventTypeEarliestMention: '最早提及',
    colStatus: '狀態',
    aboutSeoDescription:
      '香港街道命名地圖的由來、資料來源與進度。開源專案，歡迎貢獻資料、程式或想法。',
    aboutIntro:
      '平時行行下街，會好奇一條路幾時起、點解叫呢個名。最近嘗試將全港幾千條街嘅命名年份放落呢個地圖，方便睇香港嘅城市發展史。',
    aboutDataTitle: '資料來源',
    aboutDataBody:
      '近十年嘅命名，地政總署資料相對齊全；再舊啲就要翻查政府憲報。但 184 年嘅憲報簡直係無底深潭——先要搵網上版，每年差唔多兩萬幾頁；舊報更要 OCR，仲要分得清係「命名」定「改名」。',
    aboutSisterTitle: '姊妹網站',
    aboutSisterBefore: '想睇街道以外嘅地方史？姊妹網站',
    aboutSisterLink: '香港地圖集',
    aboutSisterAfter:
      '將散落各處嘅舊相、歷史檔案同地圖按真實座標整理，係一個社群協作嘅城市歷史地圖。起點係 data.gov.hk 屋宇署嘅樓宇資料，只涵蓋現存建築物；如果你知道已消失嘅舊址或者有舊相，亦歡迎補上。',
    aboutOpenSourceTitle: '開源專案',
    aboutOpenSourceBody:
      '本項目係開源專案，源碼喺 GitHub 公開。你可以 fork、改 bug、加功能，或者一齊執漏。',
    aboutGitHubCta: 'GitHub',
    footerDiscord: 'Discord',
    footerDiscordWelcome: '歡迎加入 Discord 頻道',
    footerGitHub: 'GitHub',
    linkQueueTitle: '連結佇列',
    linkQueueSeoDescription:
      '未連結至中心線的街道命名事件清單，供維護者將 event_id 對應至 STREETCODE。',
    linkQueueIntro:
      '以下命名事件已記錄於 street-events.json，但尚未在 street-centreline-map.json 建立對應連結。',
    linkQueueHint:
      '複製 event_id，於批次檔使用 link_street_code，或執行 npm run apply:street-links。',
    linkQueueReportError: '找不到未連結事件報告。請先執行 npm run report:unmapped-events。',
    linkQueueTotalsTitle: '連結狀態',
    linkQueueMapped: '已連結事件',
    linkQueueUnmapped: '待連結事件',
    linkQueueSourceFilterTitle: '來源',
    linkQueueSearch: '搜尋 event_id、街道名、地區、公告編號',
    linkQueueShowing: '顯示 {shown} / {total} 筆事件',
    linkQueueColKind: '類型',
    linkQueueColEventId: 'Event ID',
    linkQueueCopyId: '複製',
    linkQueueCopied: '已複製',
    linkQueueEmpty: '沒有符合條件的事件。',
    linkQueueSource_landsd: '地政總署',
    linkQueueSource_landsd_ati: '地政總署名冊',
    linkQueueSource_egazette_pdf: 'eGazette PDF',
    linkQueueSource_crowdsubmitted: '眾包批次',
    linkQueueSource_hkgro: 'HKGRO',
    linkQueueKindFilterTitle: '變更類型',
    linkQueueSelectAll: '全選目前列',
    linkQueueDraftTitle: '建立連結草稿',
    linkQueueDraftSelected: '已選 {count} 筆事件',
    linkQueueDraftStreetCode: 'STREETCODE',
    linkQueueDraftStreetCodePlaceholder: '例如 10115',
    linkQueueDraftCentrelineSearch: '搜尋中心線',
    linkQueueDraftCentrelinePlaceholder: '中文或英文名、街道編號',
    linkQueueDraftCentrelineError: '無法載入街道清單。',
    linkQueueDraftDownload: '下載 links.json',
    linkQueueDraftClear: '清除選取',
    linkQueueDraftHint: '下載後執行 npm run apply:street-links -- path/to/links.json',
    timelinesTitle: '記錄',
    recordsTitle: '記錄',
    recordsSubtitleSteps: [
      '加入新舊憲報為本站原始 PDF。',
      'OCR 成 Markdown 檔案。',
      '人手或用Agent 較對，修正草稿後記錄事件。',
      '如有地政總署中心線數據，加入到地圖。',
    ],
    recordsWipNotice: '此頁正待完善，內容與功能或未齊備。',
    recordsTabGazettes: '憲報',
    recordsTabStreets: '街道',
    recordsViewTabsAria: '記錄檢視',
    recordsGazettesSearch: '搜尋憲報編號、年份、街道名稱',
    recordsGazettesShowing: '顯示 {shown} / {total} 份憲報',
    recordsGazettesSortNewest: '日期：新至舊',
    recordsGazettesSortOldest: '日期：舊至新',
    recordsGazetteColNotice: '公告',
    recordsGazetteColDate: '日期',
    recordsGazetteColStreets: '街道',
    recordsGazetteColPdf: 'PDF',
    recordsGazettePdfEn: 'EN',
    recordsGazettePdfZh: '中',
    recordsGazetteExpand: '展開',
    recordsGazetteClose: '關閉',
    recordsGazetteStreetCount: '{count} 條街道',
    recordsGazetteStreetsMore: ' 等 {count} 條',
    recordsGazetteStreetCounts: '憲報內 {draft} 條街道 · 已核實連結 {linked} 條',
    recordsGazetteStreetsTitle: '憲報內提及街道',
    recordsOcrDisclaimer: '文本經由OCR擷取，未經核實。請以 PDF 原本為準。',
    recordsCorpusLoading: '載入擷取文字…',
    recordsCorpusMissing: '暫無擷取文字。',
    recordsGazettesError: '找不到憲報索引。請執行 npm run build:gazette-records。',
    recordsGazettesPeriodHint: '按憲報刊登日期年代篩選。',
    recordsGazetteInRecords: '憲報記錄',
    timelinesSeoDescription:
      '瀏覽政府憲報記錄的街道命名與相關事件，包括已連結至地圖與尚未連結的條目。',
    recordsSeoDescription:
      '瀏覽政府憲報記錄的街道命名與相關事件，包括已連結至地圖與尚未連結的條目。',
    streetPageTitle: '{name} · 街道命名歷史',
    streetPageDescription:
      '查閱{name}的政府憲報命名記錄：{count}項事件，正式命名年份為{year}。',
    streetPageNotFound: '找不到此街道頁面。',
    streetPageOpenMap: '在地圖上開啟',
    streetPageNamingYear: '正式命名年份：{year}',
    streetPageView: '街道頁面',
    timelinesIntro:
      '以下列出從憲報解析出的所有街道事件，涵蓋現存街道與已廢除或易名前之路段。目前並未收錄所有事件。',
    timelinesReportError: '找不到時間線報告。請先執行 npm run report:street-timelines。',
    timelinesTotalsTitle: '概覽',
    timelinesTotal: '時間線總數',
    timelinesOnMap: '已連結地圖',
    timelinesUnlinked: '未連結',
    timelinesFilterTitle: '連結狀態',
    timelinesSearch: '搜尋街道名、編號、事件類型（如易名、命名）',
    timelinesEventTypeFilterTitle: '事件類型',
    timelinesShowing: '顯示 {shown} / {total} 條時間線',
    timelinesEmpty: '沒有符合條件的時間線。',
    timelinesNoEvents: '沒有事件記錄。',
    timelinesUndated: '無日期',
    timelinesDetailSectionNames: '名稱',
    timelinesDetailSectionDescription: '街道說明',
    timelinesDetailSectionNotice: '公告與證據',
    timelinesDetailSectionRemarks: '備註',
    timelinesDetailSectionTechnical: '技術欄位',
    timelinesDetailNameEn: '英文名',
    timelinesDetailNameZh: '中文名',
    timelinesDetailPreviousEn: '前稱（英）',
    timelinesDetailPreviousZh: '前稱（中）',
    timelinesDetailNoticeEn: '公告編號（英）',
    timelinesDetailNoticeZh: '公告編號（中）',
    timelinesDetailNoticeUrlEn: '公告連結（英）',
    timelinesDetailNoticeUrlZh: '公告連結（中）',
    timelinesDetailEvidenceKind: '證據類型',
    timelinesDetailEvidenceNote: '證據備註',
    timelinesDetailDerivedFrom: '引用來源',
    timelinesDetailSupplementary: '補充證據',
    timelinesDetailChangeKind: '變更類型',
    timelinesDetailEventRole: '事件角色',
    timelinesDetailSource: '資料來源',
    timelinesDetailDeclaration: '命名公告',
    timelinesDetailYes: '是',
    timelinesDetailNo: '否',
    timelinesDetailViewNotice: '查看公告',
    timelinesStatus_active: '已連結',
    timelinesOpenMapStatus: '在地圖上開啟 {name}（{status} · {code}）',
    timelinesStatus_unlinked: '未連結',
    timelinesStatus_abolished: '已廢除',
    timelinesStatus_disputed: '待審',
    timelinesStatus_legacy_event_code: '舊式編號',
  },
  en: {
    siteTitle: 'HK Street Chronicle',
    seoDescription:
      'Interactive map and searchable directory of Hong Kong street naming dates from government gazette records. Explore by era and district, and help fill missing dates.',
    navMap: 'Map',
    navNames: 'Street',
    navTimelines: 'Records',
    navRecords: 'Records',
    navAbout: 'About',
    langSwitchToZh: '中',
    langSwitchAria: 'Switch to Chinese interface',
    themeSwitchToLight: 'Switch to light mode',
    themeSwitchToDark: 'Switch to dark mode',
    themeLight: 'Light mode',
    themeDark: 'Dark mode',
    navMenuAria: 'Open menu',
    searchRoadIndexing: 'Indexing roads…',
    searchRoad: 'Search road',
    mapLoading: 'Loading streets…..',
    evolution: 'Evolution',
    selectDistrict: 'Select district',
    searchDistrict: 'Search district',
    noMatchingSubDistrict: 'No matching sub-district',
    timeline: 'Timeline',
    mapHudToolbarAria: 'Map controls',
    mapHudDistrict: 'District',
    mapHudHistoricalMap: 'Old map',
    historicalMapTitle: 'Historical map',
    historicalMapNone: 'Off',
    historicalMapEmpty: 'No historical map tiles built yet. Run npm run build:historical-maps.',
    historicalMapLoading: 'Loading…',
    historicalMapOpacity: 'Opacity',
    historicalMapSuggested: 'suggested',
    historicalMapAttribution: 'Source:',
    historicalMapDatasetLink: 'LandsD historical maps',
    mapHudCloseSheet: 'Close',
    mapYearRemarksTitle: 'About map years',
    mapYearRemarksIntro:
      'The year beside each road label and the timeline slider use this priority:',
    mapYearRemarksBuilt:
      'Built or opened date when recorded (a “Built” event in the street history).',
    mapYearRemarksNaming:
      'Otherwise the earliest gazette record or official naming date for the current name. “·ref” marks earliest mention in a non-naming notice — not necessarily the naming year.',
    mapYearRemarksTimeline:
      'Tap a road for the full event timeline; built, earliest mention, and naming dates can differ by decades.',
    mapYearSuffixAttestation: '·ref',
    mapYearRemarksPending:
      '“Data to be added” means no built or naming year is available yet.',
    timelinePlay: 'Play',
    timelinePause: 'Pause',
    unknownYear: 'Data to be added',
    unnamedStreetCode: 'Street code {code}',
    periodUnknown: 'Data to be added',
    loadingReport: 'Loading report…',
    reportError: 'Street directory report not found. Run npm run report:pending-years first.',
    roadTypesTitle: 'Road types',
    periodStatsTitle: 'Naming year periods',
    periodStatsHint:
      'Map year: built → earliest mention (·ref) → earliest gazette record → naming; may differ from official naming year.',
    pendingPeriodSubtitle: 'Filter by official naming year on the street directory row.',
    timelinesPeriodSubtitle: 'Filter by years of events on each street timeline.',
    timelinesPeriodStatsHint: 'Shows streets with at least one timeline event in this decade.',
    recordsGazettesPeriodSubtitle: 'Filter by gazette publication decade.',
    periodFilterActive: 'Filtered: {period}',
    periodFilterClear: 'Clear period filter',
    periodFilterToggleExpand: 'Filter by decade',
    periodFilterToggleCollapse: 'Hide decades',
    searchTable: 'Search by street code, name, type, year, or date',
    showingStreets: 'Showing {shown} / {total} streets',
    colStreet: 'Street name',
    colType: 'Type',
    colNaming: 'Date',
    colMapYear: 'Map year',
    colNotice: 'Notice',
    colSource: 'Source',
    colPipeline: 'Curator',
    evidenceGazettePrimary: 'Gazette',
    evidenceGazetteInferred: 'Gazette (inferred)',
    evidenceGazetteMention: 'Gazette mention',
    evidenceLegalOther: 'Other legal',
    evidenceLegalMention: 'Legal mention',
    evidenceResearch: 'Research',
    evidenceResearchMention: 'Research mention',
    evidenceNews: 'News',
    evidenceNewsMention: 'News mention',
    evidenceHearsay: 'Hearsay',
    evidenceUnknown: 'Unclassified',
    evidenceOther: 'Other',
    evidenceGazettePrimaryHint:
      'Naming date from the actual government gazette notice for this street (PDF or link).',
    evidenceGazetteInferredHint:
      'Date or G.N. taken from another notice (e.g. “Previous G.N.”); see citing link.',
    evidenceGazetteMentionHint:
      'Earliest appearance of this street name in a gazette notice that is not a street-naming declaration.',
    evidenceLegalOtherHint: 'Ordinance, court, plan, or other non-gazette legal document.',
    evidenceLegalMentionHint: 'Earliest appearance of this street name in a legal document.',
    evidenceResearchMentionHint: 'Earliest appearance of this street name in research literature.',
    evidenceNewsMentionHint: 'Earliest appearance of this street name in news media.',
    evidenceResearchHint: 'Compiled research from academic or heritage institutions.',
    evidenceNewsHint: 'Newspaper, magazine, or official press — not a gazette notice.',
    evidenceHearsayHint: 'Oral tradition, forums, or other unverified secondary sources.',
    evidenceUnknownHint: 'Date recorded; source not yet classified. Gazette PDF welcome.',
    evidenceOtherHint: 'Other source; see notes.',
    colContribute: 'Help us',
    pending: 'Data to be added',
    truncatedRows: 'Showing first 500 rows. Narrow search to inspect specific roads.',
    roadTypeHighway: 'Highway',
    roadTypeMainRoad: 'Main road',
    roadTypeSecondaryRoad: 'Secondary road',
    roadTypeRestrictedRoad: 'Restricted road',
    roadTypeTunnel: 'Tunnel',
    roadTypeTrack: 'Track',
    roadTypeUnknown: 'Unknown type',
    navContribute: 'Contribute',
    contributeTitle: 'Help fill in street naming dates',
    contributeMission:
      'Only about 2% of streets have a naming year on this map. If you find a government gazette street-naming notice, please submit proof.',
    contributeNamed: 'Named',
    contributeSubmitted: 'Proofs received',
    contributeVerified: 'Community verified',
    contributePending: 'Still pending',
    contributeCoverage: 'Coverage',
    contributeCta: 'Contribute',
    contributeSingleTitle: 'One street',
    contributeSingleDesc:
      'Use “Submit proof” on the Names list, or open the form here. Provide the naming date and a gazette URL or PDF.',
    contributeBatchTitle: 'Batch upload',
    contributeBatchDesc:
      'Have many gazette PDFs? Upload files and a short note — no need to enter each street name; we process batches separately.',
    contributeBatchCta: 'Open batch form',
    contributeSingleCta: 'Open single-street form',
    contributeProofTitle: 'What counts as proof?',
    contributeProofItem1: 'A “declaration of street name” notice in the government gazette',
    contributeProofItem2: 'Government notice number (e.g. G.N. 1234) and publication date',
    contributeProofItem3: 'Link to egazette.gld.gov.hk or a gazette PDF',
    contributeProofItem4: 'Non-gazette sources (news, other legal docs): explain in remarks',
    contributeRecentTitle: 'Recently verified by contributors',
    contributeFaqTitle: 'When will status update?',
    contributeFaqInstant: 'You will see “Submitted by you” on the list right away.',
    contributeFaqPublic: 'Public “Submitted” badges usually update within a few hours (scheduled sync).',
    contributeFaqVerified: 'Naming dates on the map appear after maintainer review.',
    contributeFormsNotConfigured: 'Submission forms are not configured yet. See project docs.',
    filterAll: 'All',
    filterPendingDate: 'Data to be added',
    filterSourceTitle: 'Source',
    filterSourceNone: 'Unclassified',
    filterRecentlyVerified: 'Recently verified',
    filterNeedsProof: 'Needs proof',
    contributeFillGap: 'Help us fill the gaps',
    badgeSubmitted: 'Submitted',
    badgeSubmittedLocal: 'Submitted by you',
    badgeVerified: 'Verified',
    namesContributeHint: 'Help fill naming dates for about {count} pending streets.',
    namesBatchBarLink: 'Batch upload gazettes',
    namesBatchBarSuffix: ' (up to 10 files — street names and years detected automatically)',
    namesNoPost2000Intake:
      'We already have gazettes from 2000 onward and are processing them — please hold off on submissions for now.',
    mapSubmitProof: 'Submit naming proof',
    mapRoadCardClose: 'Close street card',
    mapRoadShare: 'Share',
    mapRoadShareAria: 'Copy street link',
    mapRoadShareCopied: 'Link copied',
    colNameHistory: 'Timeline',
    colRemarks: 'Notes',
    historyGazettePending: 'Gazette pending',
    historyGazetteInferred: 'Inferred gazette',
    eventTypeDeclare: 'Declare',
    eventTypeRename: 'Rename',
    eventTypeFormerName: 'Former name',
    eventTypeExtend: 'Extend',
    eventTypeBuilt: 'Built',
    eventTypeNameRemoved: 'Name removed',
    eventTypeEarliestMention: 'Earliest mention',
    colStatus: 'Status',
    aboutSeoDescription:
      'How the Hong Kong street naming map works, where the data comes from, and how to help. Open source — contributions welcome.',
    aboutIntro:
      'Walking around Hong Kong, you might wonder when a street was named and why it got that name. This map plots naming years for thousands of streets across the city so you can explore how the urban landscape grew over time.',
    aboutDataTitle: 'Data sources',
    aboutDataBody:
      'For the last decade or so, Lands Department records are relatively complete. Older names must be traced through the government gazette — 184 years of publications, roughly twenty thousand pages per year online. Early issues need OCR, and each notice must be classified as a new naming or a rename.',
    aboutSisterTitle: 'Sister site',
    aboutSisterBefore: 'Curious about the places around those streets? Our sister site ',
    aboutSisterLink: 'Hong Kong Atlas',
    aboutSisterAfter:
      ' is a community-built map of urban history. It gathers scattered old photos, historical archives, and maps onto real coordinates, starting from the Buildings Department’s records of present-day buildings on data.gov.hk. Vanished sites and old photos can be added by anyone who knows them.',
    aboutOpenSourceTitle: 'Open source',
    aboutOpenSourceBody:
      'This project is open source on GitHub. Fork it, fix bugs, add features, or help fill in missing naming dates.',
    aboutGitHubCta: 'GitHub',
    footerDiscord: 'Discord',
    footerDiscordWelcome: 'Welcome to the Discord channel',
    footerGitHub: 'GitHub',
    linkQueueTitle: 'Link queue',
    linkQueueSeoDescription:
      'Gazette naming events not yet linked to centreline STREETCODEs — maintainer linker queue.',
    linkQueueIntro:
      'These events are recorded in street-events.json but have no entry in street-centreline-map.json yet.',
    linkQueueHint:
      'Copy an event_id, add link_street_code in a batch file, or run npm run apply:street-links.',
    linkQueueReportError: 'Unmapped events report not found. Run npm run report:unmapped-events first.',
    linkQueueTotalsTitle: 'Linkage',
    linkQueueMapped: 'Mapped events',
    linkQueueUnmapped: 'Unmapped events',
    linkQueueSourceFilterTitle: 'Source',
    linkQueueSearch: 'Search event_id, street name, district, notice no.',
    linkQueueShowing: 'Showing {shown} / {total} events',
    linkQueueColKind: 'Kind',
    linkQueueColEventId: 'Event ID',
    linkQueueCopyId: 'Copy',
    linkQueueCopied: 'Copied',
    linkQueueEmpty: 'No events match your filters.',
    linkQueueSource_landsd: 'LandsD',
    linkQueueSource_landsd_ati: 'LandsD ATI list',
    linkQueueSource_egazette_pdf: 'eGazette PDF',
    linkQueueSource_crowdsubmitted: 'Crowd batch',
    linkQueueSource_hkgro: 'HKGRO',
    linkQueueKindFilterTitle: 'Change kind',
    linkQueueSelectAll: 'Select visible rows',
    linkQueueDraftTitle: 'Draft centreline link',
    linkQueueDraftSelected: '{count} event(s) selected',
    linkQueueDraftStreetCode: 'STREETCODE',
    linkQueueDraftStreetCodePlaceholder: 'e.g. 10115',
    linkQueueDraftCentrelineSearch: 'Find centreline',
    linkQueueDraftCentrelinePlaceholder: 'Chinese or English name, street code',
    linkQueueDraftCentrelineError: 'Could not load street directory.',
    linkQueueDraftDownload: 'Download links.json',
    linkQueueDraftClear: 'Clear selection',
    linkQueueDraftHint: 'Then run npm run apply:street-links -- path/to/links.json',
    timelinesTitle: 'Records',
    recordsTitle: 'Records',
    recordsSubtitleSteps: [
      'Host modern and colonial Gazette PDFs on-site.',
      'Run OCR to generate Markdown files.',
      'Audit and correct draft data via humans or agents to log events.',
      'Link LandsD road centrelines to render paths on the map.',
    ],
    recordsWipNotice: 'This page is under construction. Content and features may be incomplete.',
    recordsTabGazettes: 'Gazettes',
    recordsTabStreets: 'Streets',
    recordsViewTabsAria: 'Records views',
    recordsGazettesSearch: 'Search G.N., year, street names',
    recordsGazettesShowing: 'Showing {shown} / {total} gazettes',
    recordsGazettesSortNewest: 'Date: newest first',
    recordsGazettesSortOldest: 'Date: oldest first',
    recordsGazetteColNotice: 'Notice',
    recordsGazetteColDate: 'Date',
    recordsGazetteColStreets: 'Streets',
    recordsGazetteColPdf: 'PDF',
    recordsGazettePdfEn: 'EN',
    recordsGazettePdfZh: '中',
    recordsGazetteExpand: 'Expand',
    recordsGazetteClose: 'Close',
    recordsGazetteStreetCount: '{count} streets',
    recordsGazetteStreetsMore: ' +{count} more',
    recordsGazetteStreetCounts: '{draft} streets in gazette · {linked} verified on map',
    recordsGazetteStreetsTitle: 'Streets in this notice',
    recordsOcrDisclaimer:
      'This text was extracted via OCR and has not been verified. Please refer to the original PDF for accuracy.',
    recordsCorpusLoading: 'Loading extract…',
    recordsCorpusMissing: 'No extract available.',
    recordsGazettesError: 'Gazette index not found. Run npm run build:gazette-records.',
    recordsGazettesPeriodHint: 'Filter by gazette publication decade.',
    recordsGazetteInRecords: 'Gazette record',
    timelinesSeoDescription:
      'Browse gazette-recorded street naming and related events — linked to the map or still unlinked.',
    recordsSeoDescription:
      'Browse gazette-recorded street naming and related events — linked to the map or still unlinked.',
    streetPageTitle: '{name} · Street naming history',
    streetPageDescription:
      'Gazette naming record for {name}: {count} events; formal naming year {year}.',
    streetPageNotFound: 'Street page not found.',
    streetPageOpenMap: 'Open on map',
    streetPageNamingYear: 'Formal naming year: {year}',
    streetPageView: 'Street page',
    timelinesIntro:
      'Listed below are all street events parsed from the gazette, covering current streets and roads that have been abolished or renamed. Not all events have been collected yet.',
    timelinesReportError: 'Street timelines report not found. Run npm run report:street-timelines first.',
    timelinesTotalsTitle: 'Overview',
    timelinesTotal: 'Timelines',
    timelinesOnMap: 'On map',
    timelinesUnlinked: 'Unlinked',
    timelinesFilterTitle: 'Link status',
    timelinesSearch: 'Search name, code, event type (e.g. Rename, Declare)',
    timelinesEventTypeFilterTitle: 'Event type',
    timelinesShowing: 'Showing {shown} / {total} timelines',
    timelinesEmpty: 'No timelines match your filters.',
    timelinesNoEvents: 'No events recorded.',
    timelinesUndated: 'Undated',
    timelinesDetailSectionNames: 'Names',
    timelinesDetailSectionDescription: 'Street description',
    timelinesDetailSectionNotice: 'Notice & evidence',
    timelinesDetailSectionRemarks: 'Remarks',
    timelinesDetailSectionTechnical: 'Technical',
    timelinesDetailNameEn: 'English name',
    timelinesDetailNameZh: 'Chinese name',
    timelinesDetailPreviousEn: 'Previous name (EN)',
    timelinesDetailPreviousZh: 'Previous name (ZH)',
    timelinesDetailNoticeEn: 'Notice label (EN)',
    timelinesDetailNoticeZh: 'Notice label (ZH)',
    timelinesDetailNoticeUrlEn: 'Notice URL (EN)',
    timelinesDetailNoticeUrlZh: 'Notice URL (ZH)',
    timelinesDetailEvidenceKind: 'Evidence kind',
    timelinesDetailEvidenceNote: 'Evidence note',
    timelinesDetailDerivedFrom: 'Derived from',
    timelinesDetailSupplementary: 'Supplementary evidence',
    timelinesDetailChangeKind: 'Change kind',
    timelinesDetailEventRole: 'Event role',
    timelinesDetailSource: 'Source',
    timelinesDetailDeclaration: 'Declaration notice',
    timelinesDetailYes: 'Yes',
    timelinesDetailNo: 'No',
    timelinesDetailViewNotice: 'View notice',
    timelinesStatus_active: 'Linked',
    timelinesOpenMapStatus: 'Open {name} on map ({status} · {code})',
    timelinesStatus_unlinked: 'Unlinked',
    timelinesStatus_abolished: 'Abolished',
    timelinesStatus_disputed: 'Disputed',
    timelinesStatus_legacy_event_code: 'Legacy code',
  },
}

const ROAD_TYPE_KEYS = {
  Highway: 'roadTypeHighway',
  'Main Road': 'roadTypeMainRoad',
  'Secondary Road': 'roadTypeSecondaryRoad',
  'Restricted Road': 'roadTypeRestrictedRoad',
  Tunnel: 'roadTypeTunnel',
  Track: 'roadTypeTrack',
  'Unknown Type': 'roadTypeUnknown',
}

export function getRoadTypeLabel(locale, streetType) {
  const key = ROAD_TYPE_KEYS[streetType] ?? 'roadTypeUnknown'
  return translations[locale]?.[key] ?? streetType ?? translations[locale].roadTypeUnknown
}

export { COLOR_GROUP_DEFS, PERIOD_GROUP_DEFS, getPeriodLabel } from '../lib/periodGroups.js'
